import React from 'react'
import styled from 'styled-components'

import loadingGif from "../../../images/spinner.gif"

interface ButtonSubmitProps {
 	text: string,
	loading: boolean,
  className?: string,
  spinnerActive?: boolean
}

export default ({
	text,
	loading,
  className,
  spinnerActive
}: ButtonSubmitProps) => {
	return (
		<Button type="submit" className={className}>
			<StyledSpinner
				className={spinnerActive && "active"}
				src={loadingGif}
				alt="spinner"
				aria-hidden="true"
			/>
			<ButtonText className={spinnerActive ? "hidden" : ""}>
				{text}
			</ButtonText>
		</Button>
	)
}


const StyledSpinner = styled.img`
  display: none;
  height: 40px;
  width: 40px;

  &.active {
    display: block;
  }
`

const ButtonText = styled.span`
  padding-top:2px;
  display: block;

  &.hidden {
    display: none;
  }
`

const Button = styled.button`
  height: 45px;
  width: 100%;
  border-radius: 22.5px;
  background: linear-gradient(270deg, #BA1369 0%, #223f82 100%);
  color: #ffffff;
  font-family: "Adelle Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &:focus {
    outline: none;
  }
`